import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';


export default function Buymeacoffee() {
  const { t } = useTranslation();

	useEffect(() => {
		const script = document.createElement("script");
		const div = document.getElementById("supportByBMC");

		script.setAttribute("data-name", "BMC-Widget");
		script.src = "https://cdnjs.buymeacoffee.com/1.0.0/widget.prod.min.js";
		script.setAttribute("data-id", "albertorodw"); // Tu ID de Buy Me a Coffee
		script.setAttribute("data-description", t('supportCoffee'));
		script.setAttribute(
			"data-message",
			t('buyMeCoffee')
		);
		script.setAttribute("data-color", "#5F7FFF"); // Personalización del color
		script.setAttribute("data-position", "Right"); // Posición del widget
		script.setAttribute("data-x_margin", "18"); // Margen horizontal
		script.setAttribute("data-y_margin", "18"); // Margen vertical
		script.async = true;

		// Manejo del evento de carga del script
		script.onload = function () {
			const evt = document.createEvent("Event");
			evt.initEvent("DOMContentLoaded", false, false);
			window.dispatchEvent(evt);
		};

		// Añade el script al documento
		div.appendChild(script);
	}, []);

	return <div id="supportByBMC"></div>;
}
